<template>
  <div class="last_orders-widget">
      <orderView
        v-if="order.selected"
        :value="order.selected"
        :dialog="order.dialog"
        @closed="onCloseOrder"
      />
      <v-subheader>{{ lang.customers.view.last_orders.title }}</v-subheader>
      <v-container
        class="last_orders-widget-list pa-0"
        v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
      >
      <div>
        <v-row
          v-for="(order, key) in filtered"
          :key="key"
          class="list-row"
        >
          <v-col cols="7" class="info-col">
            <span
              v-text="`${lang.orders.title_s} #${order.id}`"
              class="font-weight-medium"
            /><br/>
            <span v-text="formatDate(order.datetime)" />
          </v-col>
          <v-col cols="5" class="action-col">
            <v-btn
              @click="openOrder(order)"
              icon
              medium
              class="mr-2"
              color="blue darken-2"
            >
              <v-icon medium>
                mdi-eye-outline
              </v-icon>
            </v-btn>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="repeatOrder(order)"
                  icon
                  medium
                  class="mr-2"
                  color="green darken-2"
                >
                  <v-icon medium>
                    mdi-repeat
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ lang.customers.view.last_orders.actions.repeat }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import orderView from '@/components/orders/View'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import orders from '@/components/orders/mixins/index'

export default {
  components: { orderView },
  mixins: [ appdata, utils, orders ],
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      order: {
        selected: {},
        dialog: false
      }
    }
  },
  computed: {
    filtered () {
      let data = this.list || []
      data = data.map(order => {
        return this.getOrder(order.id)
      })
      return data.sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
    }
  },
  methods: {
    openOrder (order) {
      this.order.selected = { ...order }
      this.order.dialog = true
    },
    onCloseOrder () {
      this.order.selected = {}
      this.order.dialog = false
    }
  }
}
</script>

<style lang="scss">
.last_orders-widget {
  #app & {
    height: 100% !important;
    padding: 3px 7px 3px 7px;
    border-radius: 5px;
    .v-subheader {
      justify-content: center;
    }
    &-list {
      border-top: 3px solid;
      width: 100%;
      height: 90%;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0px !important;
      .vb-content {
        padding-right: 5px !important;
      }
      .list-row {
        cursor: pointer;
        transition: all 300ms linear;
        border-bottom: 4px solid;
        border-radius: 5px !important;
        overflow: hidden;
        margin: 3px 0 !important;
        .info-col {
          padding: 7px 15px;
        }
        .action-col {
          padding: 10px 0px;
          * {
            float: right;
          }
        }
      }
    }
  }

  #app.theme--light & {
    background-image: linear-gradient(150deg, rgba(255, 172, 0, 0.15), rgba(254, 222, 0, 0.1)) !important;
    &-list {
      border-image: linear-gradient(to right,
        rgba(255,255,255,0) 0%,
        rgba(0,0,0,0.07) 20%,
        rgba(0,0,0,0.07) 50%,
        rgba(0,0,0,0.07) 80%,
        rgba(255,255,255,0) 100%
      );
      border-image-slice: 1;
      .list-row {
        background: rgba(255, 255, 255, 0.3);
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.07) 20%, rgba(0, 0, 0, 0.07) 50%, rgba(0, 0, 0, 0.07) 80%, rgba(255, 255, 255, 0) 100%);
        border-image-slice: 1;
        &:hover {
          background: rgba(255, 255, 255, 0.5);
        }
        .info-col {
          border-left: 5px solid rgba(0, 0, 0, 0.05);
        }
      }
    }
  }

  #app.theme--dark & {
    
  }
}
</style>